"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var prepareRewards_1 = __importDefault(require("./prepareRewards"));
var useTableData = function (rewards) {
    var t = (0, next_intl_1.useTranslations)('lottery');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var sortedRewards = (0, react_1.useMemo)(function () {
        return rewards === null || rewards === void 0 ? void 0 : rewards.sort(function (a, b) { return a.position - b.position; });
    }, [rewards]);
    var preparedRewards = (0, prepareRewards_1.default)({
        rewards: sortedRewards || [],
        currency: currentCurrency,
    });
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'place',
                    label: t('place'),
                },
                {
                    field: 'prize',
                    label: t('prize'),
                },
                {
                    field: 'player',
                    label: t('player'),
                },
            ],
            rows: [],
        };
        table.rows = preparedRewards.map(function (item) {
            var _a, _b;
            if (!item)
                return null;
            return {
                place: react_1.default.createElement("span", null, item.place),
                prize: (react_1.default.createElement("span", null, (_b = String((item === null || item === void 0 ? void 0 : item.amount) > 0
                    ? "".concat((_a = item === null || item === void 0 ? void 0 : item.amount) === null || _a === void 0 ? void 0 : _a.toFixed(2), " ").concat(currentCurrency)
                    : (item === null || item === void 0 ? void 0 : item.freeSpins)
                        ? "".concat(item.freeSpins, " ").concat(t('fs').toLocaleUpperCase())
                        : item.stuffReward
                            ? item.stuffReward
                            : '')) === null || _b === void 0 ? void 0 :
                    _b.toUpperCase(),
                    ((item === null || item === void 0 ? void 0 : item.bonus)
                        ? "".concat(translateLocale((item === null || item === void 0 ? void 0 : item.bonus) || ''))
                        : '').toUpperCase())),
                player: react_1.default.createElement("span", null, "-"),
            };
        });
        return table;
    }, [t, currentCurrency, preparedRewards, translateLocale]);
};
exports.useTableData = useTableData;
